import { useContext, useEffect } from 'react';
import { transmitTo, IFRAME_ACTIONS } from 'common/utils/iframe-tunnel';
import { useWindowSize } from 'common/components/useWindowSize';
import { Context as ResponsiveProviderContext } from 'client/components/common/ResponsiveProvider/Context';

export const scrollFix = {
	target: document.documentElement,
	attr: 'data-scroll',
	check() {
		return this.target.getAttribute(this.attr) === 'fixed';
	},
	set() {
		return this.target.setAttribute(this.attr, 'fixed');
	},
};

/**
 * Check whether or not scrollbar included into viewport.
 * In some environments scrollbar is a part of viewport in other no, because of this
 * it is important to increase iframe width by a scrollbar width to avoid media queries mismatch.
 *
 * Current component is developed to use only for a stories rendered in iframe by admin panel and
 * with provided controls to change platform
 */

const ScrollbarFix = () => {
	const windowSize = useWindowSize({ debounce: 300 });
	const { boundaries } = useContext(ResponsiveProviderContext);

	useEffect(
		function fix() {
			const scrollbarWidth = window.innerWidth - document.body.clientWidth;
			const query = `(min-width: ${boundaries.min}px) and (max-width: ${boundaries.max}px)`;
			const isMatch = window.matchMedia(query).matches;

			if (isMatch) return;

			const frameWidth = `calc(100% + ${scrollbarWidth}px)`;
			const frameSelector = `iframe[src$="${window.location.pathname}${window.location.search}"]`;

			scrollFix.set();

			transmitTo({
				id: 'ScrollbarFix',
				target: 'admin',
				action: IFRAME_ACTIONS.APPLY_SCROLLBAR_FIX,
				payload: {
					frameWidth,
					frameSelector,
				},
			});
		},
		[windowSize, boundaries.min, boundaries.max]
	);

	return null;
};

export default ScrollbarFix;
